import Vue from "vue";
import Router from "vue-router";
import { getToken } from "@/utils/auth";

Vue.use(Router);

const routes = [
    {
        path: "/",
        name: "Home",
        component: () => import("../pages/Home"),
        redirect: { name: 'Dashboard' },
        children: [
            {
                path: "dashboard",
                name: "Dashboard",
                title: "Dashboard",
                component: () => import("../pages/Dashboard")
            },
            {
                path: "tiktok",
                name: "TikTok",
                title: "TikTok",
                component: () => import("../pages/TikTok")
            },
            {
                path: "tiktok/*",
                name: "TikTok",
                title: "TikTok",
                component: () => import("../pages/TikTok")
            },
            {
                path: "instagram",
                name: "Instagram",
                title: "Instagram",
                component: () => import("../pages/Instagram")
            },
            {
                path: "instagram/*",
                name: "Instagram",
                title: "Instagram",
                component: () => import("../pages/Instagram")
            },
            {
                path: "account/instagram",
                name: "Account",
                title: "Account",
                component: () => import("../pages/Account"),
            },
            {
                path: "account/tiktok",
                name: "Account",
                title: "Account",
                component: () => import("../pages/Account"),
            },
            {
                path: "notification",
                name: "Notification",
                title: "Notification",
                component: () => import("../pages/Notification"),
            },
            {
                path: "orders",
                name: "Orders",
                title: "Orders",
                component: () => import("../pages/Orders")
            },
            {
                path: "profile",
                name: "Profile",
                title: "Profile",
                component: () => import("../pages/Profile")
            },
            {
                path: "shop/*",
                name: "Shop",
                title: "Shop",
                component: () => import("../pages/Shop"),
                meta: {
                    // public: true,
                }
            },
            {
                path: "biling",
                name: "Biling",
                title: "Biling",
                component: () => import("../pages/Billing/Index"),
            },
            // {
            //     path: "subscriptions",
            //     name: "subscriptions",
            //     title: "subscriptions",
            //     component: () => import("../pages/Subscriptions/Index")
            // },
            {
                path: "success",
                name: "Success",
                title: "Success",
                component: () => import("../pages/Success")
            },
            {
                path: "successpay",
                name: "Successpay",
                title: "Successpay",
                component: () => import("../pages/Successpay")
            },
            {
                path: "error",
                name: "Error",
                title: "Error",
                component: () => import("../pages/Error")
            }
        ]
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("../pages/Login"),
        meta: {
            public: true,
            onlyWhenLoggedOut: true
        }
    },
    {
        path: "/forgot-password",
        name: "Forgot Password",
        component: () => import("../pages/ForgotPassword"),
        meta: {
            public: true,
            onlyWhenLoggedOut: true
        }
    },
    {
        path: "/password_reset",
        name: "Reset Password",
        component: () => import("../pages/ResetPassword"),
        meta: {
            public: true,
            onlyWhenLoggedOut: true
        }
    }

];

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});
router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public);
    const onlyWhenLoggedOut = to.matched.some(
        record => record.meta.onlyWhenLoggedOut
    );

    const loggedIn = getToken();
    if (!isPublic && !loggedIn) {
        return next({
            path: "/login",
            query: { redirect: to.fullPath }
        });
    }

    if (loggedIn && onlyWhenLoggedOut) {
        return next("/dashboard");
    }
    next();
});

export default router;
